import { createContext } from 'react';
import { useConstraintsQuery } from '../../webapi';
import type { Constraints } from '../../webapi/application/useConstraintsQuery';
import { useClientConstraintsQuery } from '../../webapi/application/useUpsale';

type ConstraintsContextType = {
  constraints?: Constraints;
  isLoading: boolean;
};

export const ConstraintsContext = createContext<ConstraintsContextType>(
  {} as ConstraintsContextType,
);

function useConstraintsValue() {
  const tokenExists = sessionStorage.getItem('token') !== null;

  const { data: constraintsData, isLoading: constraintsIsLoading } =
    useConstraintsQuery(!tokenExists);
  const { data: clientConstraintsData, isLoading: clientConstraintsIsLoading } =
    useClientConstraintsQuery(tokenExists);

  return {
    constraints: tokenExists ? clientConstraintsData : constraintsData,
    isLoading: tokenExists ? clientConstraintsIsLoading : constraintsIsLoading,
  };
}

export default function ConstraintsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ConstraintsContext.Provider value={useConstraintsValue()}>
      {children}
    </ConstraintsContext.Provider>
  );
}
